import { tiendasApi } from '../api'

export const formularioSuscripcionPersonalizadoApiSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getFormulario: builder.query({
            // Retornamos directamente el string de la URL
            query: () => 'web/formulario-suscripcion',
            providesTags: ['FormularioSuscripcion'],
        }),

        enviarFormulario: builder.mutation({
            query: ({ body }) => ({
                url: 'web/formulario-suscripcion',
                method: 'POST',
                body,
            }),
        }),
    })
})

export const {
    useGetFormularioQuery,
    useEnviarFormularioMutation,
} = formularioSuscripcionPersonalizadoApiSlice